import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgYahoo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "yahoo",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M2 7.32845H5.81438L8.03548 13.0107L10.2855 7.32845H13.999L8.40709 20.7803H4.66943L6.20023 17.2158L2.00012 7.32845H2ZM18.3235 11.8688H14.164L17.8558 3L22 3.00018L18.3235 11.8688ZM15.2536 12.7176C16.5298 12.7176 17.5644 13.7521 17.5644 15.0282C17.5644 16.3042 16.5298 17.3388 15.2536 17.3388C13.9775 17.3388 12.9432 16.3042 12.9432 15.0282C12.9432 13.7521 13.9777 12.7176 15.2536 12.7176Z",
			fill: "#5F01D1"
		})
	})
});
export default SvgYahoo;
